import * as React from "react"

const SkipBack = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      d="M4 3H3v10h1V3Zm2.89 5L12 11.2V4.8L6.89 8ZM13 12.1V3.9a.5.5 0 0 0-.77-.42l-6.55 4.1a.5.5 0 0 0 0 .84l6.55 4.1a.5.5 0 0 0 .77-.42Z"
    />
  </svg>
)

export default SkipBack
